import { MediaType } from "../..";
import { CactiIcon } from "../../../icons";
import getAcceptedFileTypes from '../utils';
import { useMode } from '../context/ModeContext';


export const EmptyStateSection = ({ searchQuery, sectionTitle, tab, onUpload, onOpenPremiumUploadModal, acceptedFileTypes }: { searchQuery?: string; sectionTitle: string; tab?: string; onUpload?: (files: FileList) => void; onOpenPremiumUploadModal?: () => void; acceptedFileTypes?: MediaType[]; }) => {
  const { premium } = useMode();

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files.length > 0 && onUpload) {
      onUpload(files);
      // Reset the input so the same file can be selected again
      event.target.value = '';
    }
  };

  return (
    <div className="empty-state">
      <div className="empty-state__icon">
        <CactiIcon />
      </div>
      <p className="empty-state__title">
        {searchQuery ? (
          <>
            No results found in<br />
            {sectionTitle}{tab?.length ? ` ${tab}s` : ""}
          </>
        ) : `No ${sectionTitle} assets yet`}
      </p>

      {searchQuery ? (
        <>
          <p className="empty-state__description">
            Try adjusting your search
          </p>

          <a
            className="empty-state__link"
            role="button"
            aria-label="Search all assets"
            href='/'
          >
            Search all assets
          </a>
        </>
      ) : (
        onUpload && (
          <p className="empty-state__description">
            Drop files here or &nbsp;
            <label className="btn btn-link" aria-label="Upload new assets">
              upload from computer
              {
                !premium ? (
                  <input
                    type="file"
                    multiple
                    accept={acceptedFileTypes?.map(type => getAcceptedFileTypes(type)).join(',')}
                    onChange={handleFileChange}
                    style={{ display: 'none' }}
                    aria-label="Select files to upload"
                  />
                ) : (
                  <button
                    onClick={onOpenPremiumUploadModal}
                    style={{ display: 'none' }}
                  ></button>
                )
              }
            </label>
          </p>
        )
      )}
    </div>
  )
}